//----- Component --------------------------------------------------------/

// Developer :  Nicolas Pascucci

// Creation Date : 11/02/2025

// Version : 1

// Description : talles de las prendas

//

//------Changes --------------------------------------------------------------------- -------------//

// Change Date :

// Change by :

// Change description:

//

// Change Date :

// Change by :

// Change description:

//
//========================================================================/
import React, { useState, useEffect, useMemo, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import MaterialReactTable, {
  MRT_FullScreenToggleButton,
} from "material-react-table";
import { MRT_Localization_ES } from "material-react-table/locales/es"; //Tabla en español
import {
  Container,
  Box,
  Typography,
  IconButton,
  Tooltip,
  AppBar,
  Toolbar,
  Button,
  Dialog,
  DialogContent,
  DialogContentText,
  Grid,
  DialogActions,
  DialogTitle,
} from "@mui/material";
import { createTheme, ThemeProvider, useTheme } from "@mui/material";
import MuiAlert from "@mui/material/Alert";
import Navbar from "../../Navbar";
// ICONOS
import HomeRepairServiceIcon from "@mui/icons-material/HomeRepairService";
import CloseIcon from "@mui/icons-material/Close";
import EditIcon from "@mui/icons-material/Edit";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";

import { getData } from "../../../services/library";
import EdicionTalle from "./EdicionTalle";
import AgregarTalle from "./AgregarTalle";
import { logEventos } from "../../../services/services";
import { UrlApi } from "../../../services/apirest";
import DeleteIcon from "@mui/icons-material/Delete";
import BlockIcon from "@mui/icons-material/Block";
import { grey } from "@mui/material/colors";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function Talles_prendas(props) {
  let navigate = useNavigate();
  const location = useLocation();
  const [talles, setTalles] = useState();
  const [tabla, setTabla] = useState(true);
  const [editar, setEditar] = useState(false); //Estado q mostrará o no el form de edicion de clientes
  const [row, setRow] = useState();
  const [agregarTalle, setAgregarTalle] = useState(false);
  const [datosTalle, setDatosTalle] = useState({});
  const [confirmar, setConfirmar] = useState(false);
  // console.log("id", location.state.id, "completa", location);
  const [hiddenmuestrainactivo, setHiddenmuestrainactivo] = useState(false);
  const [hiddenmuestraactivos, setHiddenmuestraactivos] = useState(true);
  const [error, setError] = useState(null); //guardará el error que lance la api (si existe)
  const [notificacion, setNotificacion] = useState(false); //define si se muestra o no una notificación (snackbar)
  const [openSnack, setOpenSnack] = React.useState(false); //abre y cierra snack
  const [mensaje, setMensaje] = useState(""); //mensaje q mostrará la notif

  // const obtenerTalles = () => {
  //     getData("/stock_prendas_talles/tallesxprenda/"+location.state.id, setTalles);
  // };

  const obtenerActivos = () => {
    setHiddenmuestraactivos(true);
    setHiddenmuestrainactivo(false);
    getData(
      "/stock_prendas_talles/tallesxprendaactivo/" + location.state.id,
      setTalles
    );
  };

  const obtenerinactivos = () => {
    setHiddenmuestrainactivo(true);
    setHiddenmuestraactivos(false);
    getData(
      "/stock_prendas_talles/tallesxprendainactivo/" + location.state.id,
      setTalles
    );
  };

  //ejecuta la funcion de obtener
  useEffect(() => {
    obtenerActivos();
  }, [tabla]);

  const abrirModalConfirmar = (datosDeLaLinea) => {
    setConfirmar(true);
    setDatosTalle(datosDeLaLinea);
  };

  const handleCloseEditar = () => {
    setEditar(false);
    obtenerActivos();
  };

  const handleClickAgregarTalle = (row) => {
    setAgregarTalle(true);
  };

  const handleCloseAgregar = () => {
    setAgregarTalle(false); // Cierra el diálogo
    obtenerActivos();
  };

  const handleVolver = () => {
    setConfirmar(false);
    setTabla(true);
  };

  const marcarInactivo = async (e) => {
    logEventos(
      "Guardar talle inactivo",
      "Stock talles",
      "Se guardo talle inactivo",
      localStorage.getItem("user")
    );
    e.preventDefault();
    const response = await fetch(
      UrlApi + "/stock_prendas_talles/" + datosTalle.id,
      {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(
          datosTalle.estado === 0 ? { estado: 1 } : { estado: 0 }
        ),
      }
    );
    if (response.ok === false) {
      const error = response && response.json();
      setError(error);
      alert("Inconvenientes con la API. No se pudo guardar. ");
    } else {
      try {
        const json = await response.json();
        if (json.message) {
          setNotificacion(true);
          setOpenSnack(true);
          setMensaje(
            json.message === "OK" ? "Guardado" : "Guardado. Actualizar RTA Api."
          );
          obtenerActivos();
        } else if (json.sqlMessage) {
          json && setError(json);
          alert("SQL erróneo (" + json.code + " Errno: " + json.errno + " )");
        } else {
          alert("ERROR DESCONOCIDO.");
        }
      } catch (error) {
        if (error.toString().includes("is not valid JSON")) {
          setNotificacion(true);
          setOpenSnack(true);
          setMensaje("Guardado");
          obtenerActivos();
        } else {
          alert("Error: " + error);
        }
      }
    }
    handleVolver();
    obtenerActivos();
  };

  const columns = useMemo(
    () => [
      // { header: "ID", accessorKey: "id", size: 95 },
      { header: "Talle", accessorKey: "talle", size: 95 },
      { header: "Descripción", accessorKey: "descripcion", size: 100 },
    ],
    []
  );

  const muiSearchTextFieldProps = {
    placeholder: "Buscar..",
    sx: { minWidth: "18rem", backgroundColor: "#ffffff" },
    variant: "outlined",
    color: "primary",
    size: "small",
  };
  const tableHeadCellProps = {
    align: "left",
    sx: {
      fontSize: 16,
      color: "white",
      fontWeight: "normal",
      backgroundColor: "#2471A3",
      borderColor: "black",
    },
  };
  //*************************************************************************************************************************************//
  const globalTheme = useTheme();
  const tableTheme = useMemo(
    () =>
      createTheme({
        palette: {
          mode: globalTheme.palette.mode,
          primary: globalTheme.palette.primary, //primary color for the table
          info: {
            main: "rgb(255,122,0)", //add in a custom color for the toolbar alert background stuff
          },
          background: {
            default:
              globalTheme.palette.mode === "light"
                ? "rgb(234, 239, 241)"
                : "#000", //pure black table in dark mode for fun
          },
        },
        typography: {
          button: {
            textTransform: "none", //customize typography styles for all buttons in table by default
            fontSize: "1rem",
          },
        },
        components: {
          MuiTooltip: {
            styleOverrides: {
              tooltip: {
                fontSize: "0.8rem",
              },
            },
          },
        },
      }),
    [globalTheme]
  );

  const initialState = {
    density: "compact",
    showGlobalFilter: true,
    pagination: { pageIndex: 0, pageSize: 10 },
  };

  const volverAtras = () => {
    navigate(-1);
  };

  return (
    <>
      {tabla ? (
        <AppBar
          sx={{ position: "relative" }}
          style={{ backgroundColor: "#0979b0" }}
        >
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={volverAtras}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              Talles de {location.state.nombre}
            </Typography>
          </Toolbar>
        </AppBar>
      ) : null}
      <Container maxWidth="xl" mt={1}>
        {talles && tabla ? (
          <Box mt={2} mb={4}>
            <ThemeProvider theme={tableTheme}>
              <MaterialReactTable
                enableToolbarInternalActions={true} //las acciones al lado del search (agregar y full screen)
                enableGrouping // para permitir agrupar x estado x ej
                layoutMode="grid"
                muiTableHeadCellProps={tableHeadCellProps}
                muiTableBodyCellProps={({ row }) => ({
                  align: "left",
                  sx: {
                    backgroundColor:
                      row.original.estado === 0 ? "#efc3c3" : "#b3e6b3",
                    color: "black",
                    borderColor: "black",
                  },
                })}
                enableColumnFilters={false} //desactiva filtros x  columna
                enableHiding={false} // opcion de ocultar columna pero activando el enablecolumaction
                enableDensityToggle={false} //
                localization={MRT_Localization_ES} //idioma
                enableColumnDragging={false} //para arrastrar columnas
                initialState={initialState}
                muiSearchTextFieldProps={muiSearchTextFieldProps}
                columns={columns}
                data={talles} //con lo q la completas (esto cambia siempre)
                enableStickyFooter
                enableRowActions
                // enableEditing  //para que se pueda editar desde tabla
                positionActionsColumn="last" // posicion de la columna de acciones al final
                // ACCIONES
                renderToolbarInternalActions={(
                  { table } // boton para nuevo , al lado del buscar
                ) => (
                  <>
                    {!hiddenmuestraactivos ? (
                      <Tooltip title="Ver talles activos">
                        <IconButton
                          color="success"
                          onClick={() => {
                            obtenerActivos();
                          }}
                        >
                          <DeleteIcon />
                        </IconButton>
                      </Tooltip>
                    ) : null}
                    {!hiddenmuestrainactivo ? (
                      <Tooltip title="Ver talles inactivos">
                        <IconButton
                          color="error"
                          onClick={() => {
                            obtenerinactivos();
                          }}
                        >
                          <DeleteForeverIcon />
                        </IconButton>
                      </Tooltip>
                    ) : null}
                    <MRT_FullScreenToggleButton table={table} />
                  </>
                )}
                renderTopToolbarCustomActions={(row, table) => (
                  <>
                    <Button
                      onClick={() => {
                        handleClickAgregarTalle();
                      }}
                      color="primary"
                      //   style={{ backgroundColor: blueGrey[700], color: "white" }}
                      variant="contained"
                      size="small"
                      endIcon={<AddCircleOutlineIcon color="asd" />}
                    >
                      Agregar Talle
                    </Button>
                    <Typography variant="poster" fontSize={26}>
                      Talles
                    </Typography>
                  </>
                )}
                renderRowActions={({ row, table }) => (
                  //las acciones del costado editar y ver
                  <>
                    <div>
                      <Tooltip arrow placement="left" title="Editar">
                        <IconButton
                          onClick={() => {
                            // closeMenu();
                            setRow(row.original);
                            setEditar(true);
                          }}
                          color="primary"
                        >
                          <EditIcon />
                        </IconButton>
                      </Tooltip>
                      {row.original.estado === 0 ? (
                        <Tooltip title="Marcar como activo">
                          <IconButton
                            color="success"
                            onClick={() => abrirModalConfirmar(row.original)}
                          >
                            <CheckCircleOutlineIcon />
                          </IconButton>
                        </Tooltip>
                      ) : (
                        <Tooltip title="Marcar como inactivo">
                          <IconButton
                            onClick={() => abrirModalConfirmar(row.original)}
                            color="error"
                          >
                            <BlockIcon />
                          </IconButton>
                        </Tooltip>
                      )}
                    </div>
                  </>
                )}
              />
            </ThemeProvider>
          </Box>
        ) : null}
      </Container>
      {confirmar ? (
        <div>
          <Dialog
            open={confirmar}
            onClose={handleVolver}
            maxWidth="xs"
            fullWidth
          >
            <Box mt={1} backgroundColor={"#1F618D"}>
              <DialogTitle>
                {datosTalle.estado === 0 ? (
                  <Typography variant="h6" align="center" color="#ffffff">
                    Activar el talle : {datosTalle.descripcion}
                  </Typography>
                ) : (
                  <Typography variant="h6" align="center" color="#ffffff">
                    Desactivar el talle : {datosTalle.descripcion}
                  </Typography>
                )}
              </DialogTitle>
            </Box>
            <form onSubmit={marcarInactivo}>
              <Box
                border={0.5}
                borderColor={grey[300]}
                backgroundColor="#F4F6F6"
                p={2}
                py={2}
                mt={1}
              >
                <DialogContent>
                  <DialogContentText textAlign={"center"}>
                    {datosTalle.estado === 0 ? (
                      <>
                        {" "}
                        <b>¿Desea activar el talle ?</b>{" "}
                      </>
                    ) : (
                      <>
                        {" "}
                        <b>¿Desea desactivar el talle ?</b>{" "}
                      </>
                    )}
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Grid
                    container
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <Button
                      variant="contained"
                      onClick={handleVolver}
                      style={{ backgroundColor: "#d32f2f", color: "#ffffff" }}
                    >
                      Volver
                    </Button>
                    <Button
                      style={{ backgroundColor: "#2e7d32", color: "#ffffff" }}
                      type="submit"
                      variant="contained"
                      color="primary"
                    >
                      Confirmar
                    </Button>
                  </Grid>
                </DialogActions>
              </Box>
            </form>
          </Dialog>
        </div>
      ) : null}
      {editar && (
        <EdicionTalle
          open={editar}
          // setOpen={setEditar}
          onClose={handleCloseEditar}
          talle={row}
        />
      )}
      {agregarTalle && (
        <AgregarTalle
          open={agregarTalle}
          setOpen={handleCloseAgregar}
          prenda={location.state}
        />
      )}
    </>
  );
}

export default Talles_prendas;
